import { ApiRequest } from '@/helpers';
import { getLastMonth, getToday } from '@/utils/dateRange';

export const stats = {
  namespaced: true,
  state: getInitialState(),
  actions: {
    async fetchTeamStats({ commit, state, rootState, rootGetters }, value) {
      const resetState = value?.resetState;
      // handle all time stats
      const fromDate = value?.fromDate === undefined ? getLastMonth() : value?.fromDate;
      const toDate = value?.toDate || getToday();

      if (resetState) {
        commit('resetState');
      }
      if (!rootState.currentOrganizationId) {
        return state.statistics;
      }
      const teamId =
        value?.teamId ||
        rootGetters.currentOrganization.teams.find((t) =>
          t.members.find((m) => m.uid === rootState.currentUser.uid)
        ).id;
      const { data } = await ApiRequest({
        method: 'get',
        url: `/organizations/${rootState.currentOrganizationId}/teams/statistics`,
        params: {
          fromDate,
          toDate,
          teamId,
        },
        data: {
          teamId,
        },
      });
      commit('setTeamStats', { teamId, statistics: data.statistics });
      return data.statistics;
    },
  },
  mutations: {
    setTeamStats(state, { teamId, statistics }) {
      state.teamStats[teamId] = statistics;
    },
    resetState(state) {
      Object.assign(state, getInitialState());
    },
  },
  getters: {
    getUserStats: (state) => (uid) => {
      if (!state.teamStats) {
        return null;
      }
      return state.teamStats.find(({ user }) => user.uid === uid);
    },
    shownStats:
      (state) =>
        ({ teamId }) => {
          if (!teamId) {
            return null;
          }
          return state.teamStats[teamId];
        },
  },
};

function getInitialState() {
  return {
    teamStats: {},
  };
}
